var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"showTit"},[_c('div',{staticClass:"tit"},[_vm._t("tit")],2),_c('div',{staticClass:"handle"},[_vm._t("handle")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }